import ApiClient from './apiClient';
import { UpdateProfileDTO } from 'types/dto/order';
import { LoyaltyAccount, MemberProfile } from 'types/dto/profile';
// import { union } from 'lodash';

export const fetchTitle = async (module: string, lang: string) => {
  const response = await ApiClient.getInstance().get({
    url: `${module}/gettitle`,
    params: { lang: lang },
  });
  return response.data;
};

export const fetchMedia = async (module: string, lang: string) => {
  const response = await ApiClient.getInstance().get({
    url: `${module}/getmedia`,
    params: { lang: lang },
  });
  return response.data;
};

export const fetchUpdateAddress = async (module: string, dto: UpdateProfileDTO) => {
  const response = await ApiClient.getInstance().post({
    url: `${module}/updateAddress`,
    data: dto,
  });
  return response.data;
};

export const fetchDistrict = async (module: string, lang: string) => {
  const response = await ApiClient.getInstance().get({
    url: `${module}/getdistrict`,
    params: { lang: lang },
  });
  return response.data;
};

export const fetchProfile = async (module: string) => {
  const response = await ApiClient.getInstance().get({
    url: `${module}/getprofile`,
    // params: { ...sessionInfo },
  });
  return response.data;
};

export const fetchTier = async (module: string) => {
  const response = await ApiClient.getInstance().post({ url: `${module}/gettier`});
  return response.data;
};

export const updateProfile = async (module: string, dto: UpdateProfileDTO) => {
  const response = await ApiClient.getInstance().post({
    url: `${module}/updateprofile`,
    data: dto,
  });
  return response.data;
};


export const fetchAndUpdateProfileWithPartialProperties = async (
  unionId: string,
  // session: SessionDTO | null,
  partialProperties: Partial<LoyaltyAccount>
) => {

  //fetch profile first to avoid concurrent modification
  // const sessionInfo: SessionInfo = {
  //   sessionID: session?._tk || '',
  //   juicyAppUniqueId: session?._id || '',
  //   customerName: session?._n1 || '',
  //   customerNameZh: session?._n2 || '',
  //   preflang: session?._lg || '',
  //   lastPickUpMethodCode: session?._pu || '',
  //   needTnC: session?._tc || false,
  //   isPasswordCreated: session?._vp || false,
  //   isEmailVerified: session?._ve || false,
  //   parameterCount: 0,
  //   status: session?._st || 'new'
  // };

  const profile: MemberProfile = await fetchProfile('/profile');
  const currentLoyaltyAccount: LoyaltyAccount = profile.loyalty_account;

  const updatedLoyaltyAccount: LoyaltyAccount = {
    ...currentLoyaltyAccount,
    ...partialProperties,
  };

  const dto: UpdateProfileDTO = {
    juicyAppUniqueId: unionId || '',
    loyaltyAccount: updatedLoyaltyAccount,
  };

  //update profile
  return await updateProfile('/profile', dto);
};
